import { axiosInstance } from '../App'
import { SECURED_API_BASE } from './apiConfig'
import { NursingShiftHoursDTO } from '../dto/nursingShift/NursingShiftDTO'

const BASE = `${SECURED_API_BASE}/nursingshift`

/** Horarios de enfermería del sitio del usuario. */
export async function getNursingShiftHours(): Promise<NursingShiftHoursDTO> {
  const response = await axiosInstance.get<NursingShiftHoursDTO>(`${BASE}/getHours`)
  return response.data
}

/** Guarda la hora de inicio (HH:mm) del sitio y devuelve los turnos que resultan. */
export async function generateNursingShifts(startHour: string): Promise<NursingShiftHoursDTO> {
  const response = await axiosInstance.put<NursingShiftHoursDTO>(`${BASE}/generate`, { startHour })
  return response.data
}
